/* TPS v6 cart drawer B2 "the receipt" (Hephaestus lane D, 4 Oct 2026). House code, no library.
   Owns ONLY the B2 behaviours the engine (assets/cart.js) does not:
     1. the hardware ships line (Themis K-10 + B2-C7): composed from window.TPWStoreHours.dispatchETA()
        on every drawer render and on every open, in exactly three signed forms, and NEVER written under
        html.tps-band (removed, not hidden). No countdown, no timer.
     2. the belts (B2-C9 / B2-C10): if the drawer DOM holds any [data-tps-tob] line, or the page is a
        band page (html.tps-band, set server-side in layout/theme.liquid), the rail and the ships slot
        are REMOVED from the DOM. Liquid stays the fence (the basket test); this only catches a stale
        render and the surface test the Section Rendering request cannot know.
     3. "Add a note" (16px textarea at the foot of the line list) and the rail + (hardware only: the
        server emits + buttons only for the filtered hardware list, so it cannot add tobacco).
     4. R4A-04 / B2-C4, the HOLD: a slip holding tobacco is held by CSS (lines, rail, note, footer hidden) from its
        first frame. This file releases it (data-tpsd-art="ok") only after EVERY drawer band image has loaded with a
        real width AND img.decode() has resolved. Fail closed: an image error, or no decode within ART_TIMEOUT ms,
        sets data-tpsd-art="fail" (the neutral "Cart did not load." / "Try again" panel, no tobacco content). A late
        decode after a timeout still releases (the art is then there, which is all B2-C4 asks). "Try again" re-requests
        the same asset reference and re-arms the hold.
   Runs on every render path (cart.js renderContents, CartDrawerItems, tpw-card-v3, board-v2 drawerSync)
   through ONE MutationObserver on <cart-drawer>: the observer runs before the next paint, so a stale rail
   or ships line beside a tobacco line is never painted. */
(function () {
  "use strict";
  if (window.__tpsCartDrawerB2) return;
  window.__tpsCartDrawerB2 = true;

  var REFUSAL = "Not added.";
  var SAME_DAY = "Ships today if you order before 2pm Melbourne time.";
  var LATER = /^Ships (tomorrow|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)$/;

  function bandPage() {
    return document.documentElement.classList.contains("tps-band");
  }
  function drawerEl() {
    return document.querySelector("cart-drawer");
  }

  // B2-C7: one of three strings, or nothing at all (fail closed).
  function shipsText() {
    var H = window.TPWStoreHours;
    if (!H || typeof H.dispatchETA !== "function") return "";
    try {
      var e = H.dispatchETA(new Date());
      if (!e) return "";
      if (e.sameDay === true) return H.CUTOFF_HOUR === 14 ? SAME_DAY : "";
      if (typeof e.shipsLabel === "string" && LATER.test(e.shipsLabel)) return e.shipsLabel + ".";
    } catch (err) {}
    return "";
  }

  function drop(d) {
    /* T8 / B6-C2 + B6-C3 + B5-C4: the Free shipping node goes in the same pre-paint pass (B6-D2: silently, no text). */
    d.querySelectorAll("[data-tpsd-rail],[data-tpsd-ships],[data-tps-freeship]").forEach(function (n) {
      n.remove();
    });
  }

  function sync() {
    var d = drawerEl();
    if (!d) return;
    // B2-C9 belt + the surface belt: either test removes both nodes.
    if (bandPage() || d.querySelector("[data-tps-tob]")) {
      drop(d);
      return;
    }
    var slot = d.querySelector("[data-tpsd-ships]");
    if (!slot) return;
    var s = slot.hasAttribute("data-tpsd-ships-hold") ? "" : shipsText();
    if (!s) {
      slot.remove();
      return;
    }
    if (slot.textContent !== s) slot.textContent = s;
    slot.hidden = false;
  }

  // ---- R4A-04 / B2-C4: the art hold ------------------------------------------------------------------------
  var ART_TIMEOUT = 8000;
  function slipTob(slip) {
    return slip.classList.contains("is-tob") || !!slip.querySelector("[data-tps-tob]");
  }
  // every band image the drawer carries (strip + slip band: one src, both must be ready; display:none still loads)
  function artImgs(d) {
    return Array.prototype.slice.call(d.querySelectorAll(".cart-drawer__inner [data-tpsd-band] img"));
  }
  function artReady(img) {
    return new Promise(function (resolve, reject) {
      function decoded() {
        if (!img.naturalWidth) return reject(new Error("art: no width"));
        if (typeof img.decode !== "function") return resolve();
        img.decode().then(resolve, function () {
          // decode() also rejects when the src is swapped mid-flight; only a broken image is a failure
          if (img.complete && img.naturalWidth) resolve();
          else reject(new Error("art: decode"));
        });
      }
      if (img.complete) {
        if (img.naturalWidth) decoded();
        else if (img.getAttribute("src")) reject(new Error("art: broken"));
        else reject(new Error("art: no src"));
        return;
      }
      img.addEventListener("load", decoded, { once: true });
      img.addEventListener("error", function () { reject(new Error("art: error")); }, { once: true });
    });
  }
  // srcs whose decode() has resolved in this document. A later render of the SAME src (every stepper / remove
  // re-render of a tobacco basket) is released synchronously inside the MutationObserver callback, i.e. before the
  // next paint, so the held lines do not blink for a frame on each quantity change. Proved by painted-frame capture.
  var decodedSrc = {};
  function srcKey(img) {
    return img.currentSrc || img.src || "";
  }
  function setArt(slip, state) {
    if (!slip.isConnected) return;
    slip.setAttribute("data-tpsd-art", state);
    if (state === "wait") slip.setAttribute("aria-busy", "true");
    else slip.removeAttribute("aria-busy");
  }
  function armHold(d) {
    var slip = d.querySelector(".tpsd-slip");
    if (!slip || slip.__tpsdArmed) return;
    slip.__tpsdArmed = true;
    if (!slipTob(slip)) return; // nothing is held on a slip without tobacco
    var imgs = artImgs(d);
    if (!imgs.length) {
      // a tobacco line with no band render at all (Liquid disagreement): never reveal it
      setArt(slip, "fail");
      return;
    }
    if (imgs.every(function (img) { return img.complete && img.naturalWidth > 0 && decodedSrc[srcKey(img)]; })) {
      setArt(slip, "ok");
      return;
    }
    setArt(slip, "wait");
    var settled = false;
    var timer = setTimeout(function () {
      if (!settled) setArt(slip, "fail");
    }, ART_TIMEOUT);
    Promise.all(imgs.map(artReady)).then(
      function () {
        settled = true;
        clearTimeout(timer);
        imgs.forEach(function (img) {
          decodedSrc[srcKey(img)] = true;
          // T-2A (lane B, 4 Oct): the band snippet's own onerror flags its wrapper .is-artfail (img display:none,
          // the alt sentence shown). A good decode after Try again clears that flag, as the page guard
          // (layout/theme.liquid) and Ariadne do, so the art, not the sentence, is what paints. Without this the
          // retry reloaded the art and left it hidden (measured: 101 of 101 post-retry frames at 1440).
          var w = img.closest(".tps-board-warn");
          if (w) w.classList.remove("is-artfail");
        });
        setArt(slip, "ok");
      },
      function () {
        settled = true;
        clearTimeout(timer);
        setArt(slip, "fail");
        var b = slip.querySelector("[data-tpsd-retry]");
        if (b && d.contains(document.activeElement)) {
          try { b.focus({ preventScroll: true }); } catch (e) {}
        }
      }
    );
  }
  // P3-C7 (Themis perf-band, 5 Oct): the band <img> carries srcset, so it paints a srcset CANDIDATE. Re-setting `src`
  // alone re-selects the same candidate and may replay the failed response without a new request. Every candidate is
  // nonced with ONE value (strip + slip share one request), srcset is set before src, sizes is never touched (one
  // sizes everywhere, D-P3-4). A previous nonce is stripped first, so repeated retries never stack parameters.
  function bust(u, n) {
    u = u.replace(/([?&])tpsr=\d+&?/, "$1").replace(/[?&]$/, "");
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "tpsr=" + n;
  }
  function bustSet(set, n) {
    return set.split(",").map(function (c) {
      c = c.trim();
      var i = c.search(/\s/);
      return i < 0 ? bust(c, n) : bust(c.slice(0, i), n) + c.slice(i);
    }).join(", ");
  }
  function retryArt(btn) {
    var d = drawerEl();
    var slip = btn.closest(".tpsd-slip");
    if (!d || !slip) return;
    var n = Date.now();
    // The drawer's band images only. The warmer (P2-C2/P2-C5) is not a hold subject and is no longer touched here, so a
    // page without a warm node (every tobacco surface, D-P2-2) cannot make this throw.
    artImgs(d).forEach(function (img) {
      var src = img.getAttribute("src");
      var set = img.getAttribute("srcset");
      if (!src && !set) return;
      if (set) img.setAttribute("srcset", bustSet(set, n));
      if (src) img.setAttribute("src", bust(src, n));
    });
    decodedSrc = {};
    slip.__tpsdArmed = false;
    // R8-A11 (Argus R8, WCAG 2.4.3): the held state hides the hold panel (visibility), which dropped focus to <body> on
    // every press. While THIS retry is held the panel stays visible, so focus stays on Try again; on release focus goes to
    // the drawer heading (art ok: the panel is gone) or stays on Try again (failed again). Focus only moves if it was on the
    // button. The hold itself (what is hidden, when, the 8 s timeout) is untouched: armHold below decides it.
    var hold = btn.closest("[data-tpsd-hold]");
    var had = document.activeElement === btn;
    if (hold) hold.style.visibility = "visible";
    var mo = new MutationObserver(release);
    function release() {
      var st = slip.getAttribute("data-tpsd-art");
      if (st === "wait") return;
      mo.disconnect();
      if (hold) hold.style.visibility = "";
      if (!had || !slip.isConnected) return;
      if (st === "ok") {
        var h = d.querySelector(".tpsd-dt");
        if (h) {
          if (!h.hasAttribute("tabindex")) h.setAttribute("tabindex", "-1");
          try { h.focus({ preventScroll: true }); } catch (e) {}
        }
      } else if (document.activeElement !== btn) {
        try { btn.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    mo.observe(slip, { attributes: true, attributeFilter: ["data-tpsd-art"] });
    armHold(d);
    // settled synchronously (no wait state was entered): release now instead of waiting for a record
    if (slip.getAttribute("data-tpsd-art") !== "wait") { mo.takeRecords(); release(); }
  }

  // ---- Flash R7 #2: the ONE band warmer on non-tobacco pages (Themis P2-C1..C5, Daedalus D-P2-1..3, 5 Oct) -------
  // snippets/cart-drawer.liquid renders [data-tpsd-warm] with data-src / data-srcset / data-sizes (the band's own
  // strings, lifted from a captured render of tps-warning-band) and NO live src, and renders nothing at all on a
  // tobacco surface. It is hydrated ONCE, on the first of: (a) idle after window load (requestIdleCallback, 3 s cap;
  // setTimeout 3 s without it), (b) pointerenter / touchstart / focus on the cart icon, (c) any /cart/add request being
  // SENT (fetch is wrapped as a pure pass-through that only looks at the URL). Hydration sets sizes, then srcset, then
  // src, so the browser fetches the candidate the drawer strip will select, never the 1920 file first. Fetch is not
  // display (D-4): the warmer never enters artImgs(), never writes decodedSrc and is never a release condition (P2-C2).
  // Belt (D-P2-2): if the head carries the tobacco-surface preload, this does nothing at all.
  (function warmer() {
    if (document.querySelector("link[data-tps-band-preload]") || bandPage()) return;
    var done = false;
    var realFetch = window.fetch;
    function node() {
      return document.querySelector("img[data-tpsd-warm]");
    }
    function hydrate() {
      if (done) return;
      var w = node();
      if (!w) return;
      done = true;
      var sizes = w.getAttribute("data-sizes");
      var set = w.getAttribute("data-srcset");
      var src = w.getAttribute("data-src");
      if (sizes) w.setAttribute("sizes", sizes);
      if (set) w.setAttribute("srcset", set);
      if (src) w.setAttribute("src", src);
      w.setAttribute("data-tpsd-warmed", "");
      if (window.fetch === wrapped) window.fetch = realFetch;
      document.removeEventListener("pointerover", intent, true);
      document.removeEventListener("touchstart", intent, true);
      document.removeEventListener("focusin", intent, true);
    }
    if (!node()) return;
    function isAdd(u) {
      try {
        u = typeof u === "string" ? u : (u && u.url) || String(u);
        return /\/cart\/add(\.js)?(\?|$)/.test(new URL(u, location.href).pathname + "?");
      } catch (e) {
        return false;
      }
    }
    function wrapped(input) {
      if (!done && isAdd(input)) hydrate();
      return realFetch.apply(this, arguments);
    }
    if (typeof realFetch === "function") window.fetch = wrapped;
    function intent(e) {
      var t = e.target;
      if (t && t.closest && t.closest("#cart-icon-bubble")) hydrate();
    }
    document.addEventListener("pointerover", intent, { capture: true, passive: true });
    document.addEventListener("touchstart", intent, { capture: true, passive: true });
    document.addEventListener("focusin", intent, true);
    function idle() {
      if ("requestIdleCallback" in window) window.requestIdleCallback(hydrate, { timeout: 3000 });
      else setTimeout(hydrate, 3000);
    }
    if (document.readyState === "complete") idle();
    else window.addEventListener("load", idle, { once: true });
  })();

  // R5A-13: the root gutter (scrollbar-gutter:stable) is painted by the canvas colour only; html.tpsd-open gives it the
  // scrim tone while the drawer is open (CSS). Toggled with the drawer's own active class.
  function gutter(d) {
    document.documentElement.classList.toggle("tpsd-open", d.classList.contains("active"));
  }

  function watch(d) {
    if (d.__tpsdWatched) return;
    d.__tpsdWatched = true;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].type === "childList") {
          sync();
          armHold(d);
          gutter(d);
          return;
        }
      }
    }).observe(d, { childList: true, subtree: true });
    // a drawer left open across a business-day boundary re-reads the clock on every open
    new MutationObserver(function () {
      if (d.classList.contains("active")) sync();
      gutter(d);
    }).observe(d, { attributes: true, attributeFilter: ["class"] });
  }

  function say(msg) {
    var r = document.getElementById("CartDrawer-LiveRegionText");
    if (!r) return;
    // R4T-02: write into the permanent child <span> (p:empty would hide an empty <p> from the a11y tree)
    var slot = r.firstElementChild || r;
    r.setAttribute("aria-hidden", "false");
    slot.textContent = "";
    setTimeout(function () {
      slot.textContent = msg;
    }, 30);
  }

  // "Add a note": reveal the 16px textarea at the foot of the line list (no iOS zoom), focus it.
  function toggleNote(btn) {
    var panel = document.getElementById("CartDrawer-NotePanel");
    if (!panel) return;
    var open = panel.hidden;
    panel.hidden = !open;
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      var ta = panel.querySelector("textarea");
      try {
        panel.scrollIntoView({ block: "nearest" });
      } catch (e) {}
      if (ta) ta.focus({ preventScroll: true });
    }
  }

  // Rail +: hardware variant ids only (server-filtered list). Re-renders the drawer in the same request
  // (B2-C8: the add path refreshes the drawer before it is next shown) and keeps it open.
  function railAdd(btn) {
    if (btn.getAttribute("aria-disabled") === "true") return;
    var vid = parseInt(btn.getAttribute("data-tpsd-add"), 10);
    var d = drawerEl();
    if (!vid || !d) return;
    btn.setAttribute("aria-disabled", "true");
    var ids = typeof d.getSectionsToRender === "function"
      ? d.getSectionsToRender().map(function (s) { return s.id; })
      : ["cart-drawer", "cart-icon-bubble"];
    var url = (window.routes && window.routes.cart_add_url) || "/cart/add";
    if (!/\.js$/.test(url)) url += ".js";
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: vid, quantity: 1, sections: ids, sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (res) {
          if (!r.ok || res.status) throw new Error("refused");
          return res;
        });
      })
      .then(function (res) {
        try { document.dispatchEvent(new CustomEvent("tps:src", { detail: "drawer-rail" })); } catch (e) {} // EXP-0002 stamp, assets/tps-src.js
        if (typeof d.renderContents === "function" && res.sections) {
          d.renderContents(res);
        }
        // focus the new line's name (the + that was pressed no longer exists). Synchronously: renderContents writes
        // the DOM now and opens on a timer, and cart.js's focus-in only moves focus that is OUTSIDE the drawer.
        var line = d.querySelector('.cart-item[data-variant="' + vid + '"] .cart-item__name');
        if (line) {
          try { line.focus({ preventScroll: true }); } catch (e) { line.focus(); }
          try { line.scrollIntoView({ block: "nearest" }); } catch (e) {}
          // R4T-04 (Tiresias R4): the add was silent. Announce the new line's own name through the one announcer
          // (text already on the page; no new string until Cicero's "Added" is signed).
          say(line.textContent.replace(/\s+/g, " ").trim());
        }
        // No cartUpdate publish: the drawer's own <cart-drawer-items> subscribes to it and would re-fetch and
        // re-render the drawer a second time, dropping the focus placed above (measured). The header bubble is
        // already refreshed by the same sections payload, as on every other add path (pdpv9, cards).
      })
      .catch(function () {
        btn.removeAttribute("aria-disabled");
        say(REFUSAL);
      });
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var note = t.closest("cart-drawer [data-tpsd-note]");
    if (note) {
      e.preventDefault();
      toggleNote(note);
      return;
    }
    var retry = t.closest("cart-drawer [data-tpsd-retry]");
    if (retry) {
      e.preventDefault();
      retryArt(retry);
      return;
    }
    var add = t.closest("cart-drawer [data-tpsd-add]");
    if (add) {
      e.preventDefault();
      railAdd(add);
    }
  });

  function boot() {
    var d = drawerEl();
    if (!d) return;
    watch(d);
    sync();
    armHold(d);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
